import React from "react";
import { useTranslation } from "react-i18next";
import { StatusDisplay } from "../../loads/partials/LoadStatusChip";

function AlpInboundLoadFcaStatus(props: any) {
    const { status, label, textable, chip } = props;
    const { t } = useTranslation();

    if ( status === 'pending' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-primary-500"
                label={ label ? label : t('approval pending') }
                badgeSeverity="info"
            />
        );
    }

    if ( status === 'sent' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-black-500"
                label={ label ? label : t('approval requested') }
                badgeSeverity="info"
            />
        );
    }

    if ( status === 'approved' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('approved') }
                badgeSeverity="success"
            />
        );
    }

    return (
        <span></span>
    );
}

export default AlpInboundLoadFcaStatus;
